import { FaCar } from "react-icons/fa";
import { FaHandSparkles } from "react-icons/fa";
import { FaBugSlash } from "react-icons/fa6";
import { GiCarWheel } from "react-icons/gi";
import { TbCarDoor } from "react-icons/tb";
import { GiSparkles } from "react-icons/gi";
import { MdDry } from "react-icons/md";
import "./PackageInfo.css";
function Exterior() {
  return (
    <div className="package-info">
      {/* all sections */}

      <>
        <section className="service-hero">
          <div className="service-content">
            <span className="service-tag">PREMIUM DETAILING SERVICE</span>

            <h1>Exterior Detailing</h1>

            <p className="service-description">
              Restore a clean, glossy finish while removing dirt, road grime,
              bugs, and other buildup from your vehicle’s exterior.
            </p>
          </div>

          <div className="service-image">
            <img src="/images/exterior.png" alt="Exterior Detailing" />
          </div>
        </section>

        <section className="service-cards">
          <div className="card">
            <div className="card-header">
              {/* Icon */}
              <FaCar color="#f703ff" />
              <h2>What's Included</h2>
            </div>

            <div className="two-column-list">
              <div>
                <div className="feature">
                  {/* Icon */}
                  <FaHandSparkles color="#f703ff" />
                  <span>Full hand wash</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <GiCarWheel color="#f703ff" />
                  <span>Wheel and tire cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <FaBugSlash color="#f703ff" />
                  <span>Bug and road-grime removal</span>
                </div>

                <div className="feature">
                  {/* Icon */}
                  <TbCarDoor color="#f703ff" />
                  <span>Door-jamb cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <GiSparkles color="#f703ff" />
                  <span>Exterior window cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <MdDry color="#f703ff" />
                  <span>Hand drying</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </div>
  );
}
export default Exterior;
